import { render, staticRenderFns } from "./CommunityNewChatModal.vue?vue&type=template&id=361f9a1b&scoped=true&"
import script from "./CommunityNewChatModal.vue?vue&type=script&lang=js&"
export * from "./CommunityNewChatModal.vue?vue&type=script&lang=js&"
import style0 from "./CommunityNewChatModal.vue?vue&type=style&index=0&id=361f9a1b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "361f9a1b",
  null
  
)

export default component.exports